import { Outlet, useNavigate, useParams } from "react-router-dom";
import SockJS from 'sockjs-client';
import { useEffect, useState, createContext, useContext } from "react";
import { over } from 'stompjs';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import NiceModalHandler from '@ebay/nice-modal-react';
import PaymentModal from "modals/handler/PaymentModal";
import { useSelector } from "react-redux";
import { requester } from "App";
import { AuthContext } from "providers/AuthProvider";
import { useDispatch } from "react-redux";
import { DeviceReducer } from "shared/redux/reducers/device/DeviceReducer";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
export const OutletContext = createContext();

function WebSocketContainer() {
    const { id } = useParams();
    const [stompClient, setClient] = useState();
    const navigate = useNavigate();
    const paymentModal = useModal("payment");
    const testPaymentModal = useModal("testPayment");
    const paymentCompleteModal = useModal("paymentComplete");
    const itemDispensingModal = useModal("itemDispensing");
    const waitForItemCollectionModal = useModal('waitForItemCollection');
    const waitingForProductsModal = useModal('waitingForProducts');
    const cartData = useSelector((state) => state.cart.products);
    const paymentUrlData = useSelector((state) => state.payment.paymentUrl);
    // const deviceCodeData = useSelector((state) => state.device.deviceCode);
    // const [deviceCodeData, setDeviceCodeData] = useState();
    let deviceCodeData = null;
    const [cartList, setCartList] = useState([]);
    const { userId } = useContext(AuthContext);
    const dispatch = useDispatch();


    useEffect(() => {
        // let Sock = new SockJS(`http://${window.location.hostname}:8080/api/ws`);
        let Sock = new SockJS(`https://puffuapp.com:8080/api/ws`);
        setClient(over(Sock));
        
    }, []);

    useEffect(() => {
        setCartList(cartData);
    }, [cartData])

    useEffect(() => {
        if (stompClient) {
            stompClient.connect({}, onConnected, onError);
        }
    }, [stompClient]);


    const onConnected = () => {
        stompClient.subscribe(`/chatroom/${id}`, onMessageReceived);

        // sendMessage("test message");
        // stompClient.subscribe('/user/' + userData.username + '/private', onPrivateMessage);
        // userJoin();
    }
    const onMessageReceived = (payload) => {
        
        var payloadData = JSON.parse(payload.body);


        var payloadData = JSON.parse(payload.body);
        

        
        if (payloadData.code === "waitingForProducts") {
            // alert(payloadData.deviceCode);
            if (window.BRIDGE && window.BRIDGE.getDeviceCode) {
                let deviceCode = window.BRIDGE.getDeviceCode();
                // alert(deviceCode);
                // alert(deviceCodeData);
                
                
                if (deviceCode === payloadData.deviceCode) {
                    // alert(JSON.stringify(payloadData));
                    NiceModal.show("waitingForProducts", { data: payloadData.userId, storeCode: payloadData.roomId });
                }
            }

        }
        if (payloadData.code === "order") {
            // if (window.location.pathname === `/ws/5/main`) {
            // const newTotal = cartList.reduce((acc, item) => acc + item.quantity * item.price, 0);

            // let data = {
            //     storeCode: payloadData.roomId,
            //     orderProducts: cartList,
            //     amount: newTotal,
            //     userId: payloadData.userId,
            // };




            if (window.BRIDGE && window.BRIDGE.sendOut) {
                if (window.BRIDGE && window.BRIDGE.getDeviceCode) {
                    let deviceCode = window.BRIDGE.getDeviceCode();
                    // setDeviceCodeData(payloadData.deviceCode);
                    deviceCodeData = payloadData.deviceCode;


                    if (deviceCode === payloadData.deviceCode) {
                        navigate(`/ws/${id}/main/receiveItem`)
                        
                        dispatch(CartReducer.actions.reset());
                        
                        // itemDispensingModal.show();
                    } else {
                        // waitForItemCollectionModal.show();
                    }
                }
                const jsonData = payloadData.content;
                
                const jsonString = JSON.stringify(jsonData);
                const base64EncodedString = btoa(jsonString);
                window.BRIDGE.sendOut(base64EncodedString);
            } else {
                // waitForItemCollectionModal.show();
            }
            // paymentModal.remove();
            // itemDispensingModal.show();
            // 
            // if(window.BRIDGE && window.BRIDGE.getDeviceCode){
            //     window.BRIDGE.getDeviceCode();
            // }


            // if (cartList && cartList.length > 0) {
            //     requester.testPurchaseOrder(data, (result) => {
            //         if (result.code === 0) {
            //             if (window.BRIDGE && window.BRIDGE.sendOut) {
            //                 const jsonData = payloadData.content;
            //                 const jsonString = JSON.stringify(jsonData);
            //                 const base64EncodedString = btoa(jsonString);
            //                 window.BRIDGE.sendOut(base64EncodedString);
            //             }
            //             // if(paymentModal.visible){
            //             paymentModal.remove();
            //             // waitForItemCollectionModal.show();
            //             itemDispensingModal.show();
            //             // }


            //         } else {
            //             // reject(new Error('Purchase order failed')); // 실패 시 에러 반환
            //             
            //         }
            //     });
            // }
            // }
        }
        if (payloadData.code === "unsetOperating") {
            if (window.BRIDGE && window.BRIDGE.getDeviceCode) {
                let deviceCode = window.BRIDGE.getDeviceCode();

                
                let deviceCodeData = payloadData.deviceCode;
                
                
                if (deviceCode === deviceCodeData) {
                    
                    itemDispensingModal.remove();
                    // paymentCompleteModal.show();
                } else {
                    
                    // waitForItemCollectionModal.show();
                    waitForItemCollectionModal.remove();
                }
            }
        }

        // if (payloadData.content === "start") {
        //     if (window.location.pathname === `/ws/${id}/home`) {
        //         navigate(`/ws/${id}/main`);
        //     }
        // } else if (payloadData.content === "order") {
        //     if (window.location.pathname === `/ws/${id}/main`) {
        //         paymentModal.remove();
        //         NiceModal.show("paymentComplete", { id: id });
        //         window.BRIDGE.testAndroid();
        //     }
        // }else {
        //     if (window.location.pathname === `/ws/${id}/payment`) {
        //         // alert("test");
        //         paymentModal.remove();
        //         NiceModal.show("paymentComplete", { id: id });
        //         // window.BRIDGE.testAndroid();
        //     }
        // }
    }
    const onError = (err) => {
        
    }

    // 웹소켓 서버로 메시지 보내기
    const sendMessage = (message) => {
        // 적절한 목적지 주소와 보낼 메시지를 설정
        const destination = `/app/sendMessage/${id}`;
        // stompClient.send 메소드를 사용하여 메시지 전송
        stompClient.send(destination, {}, JSON.stringify({ content: message }));
    }

    const unsubscribe = () => {
        stompClient.unsubscribe();
    }

    return (
        <OutletContext.Provider value={{ id, sendMessage, unsubscribe }}>
            <Outlet />
        </OutletContext.Provider>

    );
}

export default WebSocketContainer;

